<template>
  <div class="top-picker">
    <el-radio-group v-model="dateType" @input="changeType">
      <el-radio-button :label="1">日</el-radio-button>
      <el-radio-button :label="2">周</el-radio-button>
      <el-radio-button :label="3">月</el-radio-button>
    </el-radio-group>
    &ensp;

    <!-- 显示对应的三个日期类型组件，使用v-if会导致ui错乱，暂时使用v-show替代 -->
    <ElDatePicker
      v-show="dateType === 3"
      v-model="datemonth"
      :picker-options="datetimeOption"
      :clearable="false"
      type="month"
      placeholder="请选择"
      style="width: 100px"
      @change="changeDate"
    />
    <ElDatePicker
      v-show="dateType === 2"
      v-model="dateweek"
      :picker-options="datetimeOption"
      :clearable="false"
      type="date"
      show-week-numbers
      placeholder="请选择"
      style="width: 100px"
      @change="changeDate"
    />
    <ElDatePicker
      v-show="dateType === 1"
      v-model="datetime"
      :picker-options="datetimeOption"
      :clearable="false"
      type="date"
      placeholder="请选择"
      style="width: 100px"
      @change="changeDate"
    />
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'topDatePick',
  props: {
    value: {
      type: Number
    },
    size: {
      type: String,
      default: 'default'
    },
    default: {
      type: String
    }
  },
  computed: {
    dateType: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      datemonth: '',
      datetime: '',
      dateweek: '',
      datetimeOption: {
        firstDayOfWeek: 1,
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  created() {
    this.datemonth = moment().format('YYYY-MM')
    this.datetime = this.default || moment().format('YYYY-MM-DD')
    this.dateweek = moment().format('YYYY-MM-DD')
  },
  methods: {
    changeDate(val) {
      this.$emit('on-select', val)
    },
    changeType(val) {
      let datetime
      if (val === 3) datetime = this.datemonth
      else if (val === 2) datetime = this.dateweek
      else datetime = this.datetime
      this.$emit('on-select', datetime)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit('on-select', this.datetime)
    })
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';
.top-picker {
  ::v-deep .el-radio-button__inner {
    background: transparent;
    color: $primary-color;
  }
}
</style>
